import {gql} from "@apollo/client";

export default gql`
  mutation inviteManager($data: AddManagerInput!) {
    inviteManager(data: $data)
  }
`;
